//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import * as moment from "moment";


// custom pages
import Table from "components/Table/Table";
import styles from "./styles";
import Loader from "components/Loader/Loader";
import Context from "context/context";
import { useTranslation } from 'react-i18next';
import LinearProgress from '@material-ui/core/LinearProgress';

//Helpers
import {dateFormat, pointsFormat} from "helpers/dataFormat"

export default function PendingRedeemed(props) {
  const {
    data,
    offset,
    count,
    setOffset,
    currentTab,
    viewMore,
    setViewMore,
    viewMoreEnd,
    noData,
    response,
    loading,
  } = props;

  const classes = styles();
  const { state, dispatch } = useContext(Context);

  const { t, i18n } = useTranslation();
  // const callback = () => {
  //   if (viewMoreEnd[currentTab]?.length == 0) {
  //     setOffset({ ...offset, [currentTab]: offset[currentTab] + 1 });
  //   }
  // };
  // const scrollRef = useBottomScrollListener(callback);
  const handlePagination = (value) => {
    console.log(value,'this is the paginationvalues')
     setOffset({ ...offset, [currentTab]: value });
   };
  // point format func
  // const pointFormat = (point) => {
  //   var nfObject = new Intl.NumberFormat('en-US');
  //   var res = nfObject.format(point);
  //   return res;
  // };

  const headings = [
    "Date of Transaction",
    "Transaction Type",
    "Product Description",
    "Points Expiration Date",
    "Points Earned",
    "Business Name",
  ];
  return (
    <React.Fragment>
      {response ? (
        <div className='non-sales-table-wrapper'>
          {' '}
          <div
            className={viewMore[currentTab] ? classes.tableDivPending : null}
            // ref={scrollRef}
          >
            <Table
              headings={headings.map((i) => (
                <div key={t(i)} className={classes.nonSalesHeadings}>{t(i)}</div>
              ))}
              data={data.map((p, i) => [
                p.date_of_transaction &&
                p.date_of_transaction =='N/A'?p.date_of_transaction:dateFormat(p.date_of_transaction,i18n.language),
                t(p.transaction_type),
                t(p.rule_description),
                state?.ALA?.["Loyalty_Account.points_not_expiring"] == true ? "N/A" : p.points_expiration_date =='N/A'?p.points_expiration_date:p.points_expiration_date &&
                dateFormat(p.points_expiration_date,i18n.language),
                pointsFormat(p?.points,i18n.language),
                t(p?.loyalty_organization_name),
              ])}
              offset={offset[currentTab]}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
              disablePagination={false}
              currentTab={currentTab}
              sorting={true}
              sortingFields={{
                column: 'Date of Transaction',
                row: 'date_of_transaction',
                position: 0,
              }}
            />
          </div>
          {/* {!noData[currentTab] && !viewMore[currentTab] && (
            <div
              className={classes.viewMore}
              style={{ fontSize: '1rem' }}
              onClick={() => {
                setViewMore({ ...viewMore, [currentTab]: true });
                setOffset({
                  ...offset,
                  [currentTab]: offset[currentTab] + 1,
                });
              }}
            >
              <span className={classes.viewMoreText}>{t('View More')}</span>
            </div>
          )} */}
          {/* {viewMoreEnd[currentTab] && viewMoreEnd[currentTab].length > 0 && (
            <div className={classes.viewMore}>{viewMoreEnd[currentTab]}</div>
          )} */}
        </div>
      ) : (
        <Loader Loading={!response} top={'15%'}></Loader>
      )}
      {viewMore[currentTab] && loading ? (
        <LinearProgress style={{ margin: '10px 0px', color: '#3891CB' }} />
      ) : null}
    </React.Fragment>
  );
}
